export const PAYMENT_STATUS_CONFIG = {
  failed: {
    icon: 'paymentFailedIcon',
    title: 'Payment failed',
    description:
      'This could be due to a technical issue.\nAny amount deducted will be refunded in 3 - 5 working days.',
    ctaText: 'Try Again',
    retryPayment: true
  },
  cancelled: {
    icon: 'paymentFailedIcon',
    title: 'Payment cancelled',
    description:
      'Your transaction has been cancelled. This could be due to cancellation by you or other reasons. You can try again if you wish to proceed with the payment.',
    ctaText: 'Try Again',
    retryPayment: true
  },
  success: {
    icon: 'greenTick',
    title: 'Payment successful!',
    description: 'Your transaction has been completed successfully. Thank you for your payment.',
    ctaText: 'Okay, Got it',
    retryPayment: false
  }
}

export const PAYMENT_STATUS_QUERY_PARAMS = ['status', 'txnId', 'amount', 'loan_ids']
